// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"5f2b1ece","453":"95c958e2","848":"43f3030c"}[chunkId] + ".chunk.js";
};